import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonService } from './services/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { AuthenticationService } from './services/authentication.service';
import { Subscription } from 'rxjs';
import { ApiService } from './services/api-data.service';
import { ToastrService } from 'ngx-toastr';
import { URLS } from './_config/api.config';
import { ScriptService } from './services/script.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'relevant-redio-web';
    // isServer: boolean;
    public isBrowser: boolean;

    isLoggingOut = false;
    isModalActive = false;

    @ViewChild('cancelLogoutModal') cancelLogoutModal;
    private subscription: Subscription = new Subscription();
    @ViewChild('openLogoutModal') openLogoutModal;
    @ViewChild('openSurveyModal') openSurveyModal;

    private routerSubscription: any;

    constructor(
        @Inject(DOCUMENT) private document: any,
        @Inject(PLATFORM_ID) private platformId: Object,
        private commonService: CommonService,
        private router: Router,
        private meta: Meta,
        private titleService: Title,
        private dataService: ApiService,
        private toastr: ToastrService,
        private authService: AuthenticationService,
        private ScriptService: ScriptService
    ) {
        // this.isServer = isPlatformServer(this.platformId);
        this.isBrowser = isPlatformBrowser(platformId);

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                this.setMetaTags();

                const canonicalUrl = event.urlAfterRedirects;
                this.updateCanonicalTag(canonicalUrl);

                let isLogin = this.authService.hasToken();
                let userEmail = this.commonService.localStorageGet('email');

                // if (isLogin) {
                //     if (window.clarity) {
                //         window.clarity("identify", userEmail, canonicalUrl);
                //     }
                // }
            });

        this.commonService.logoutModal$.subscribe(() => {
            this.openLogoutModal.nativeElement.click();

        });

        this.commonService.surveyModalTrigger$.subscribe(() => {
            this.openSurveyModal.nativeElement.click();
        });

    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            const modalElement = document.getElementById('surveyModal');
            if (modalElement) {
                modalElement.addEventListener('shown.bs.modal', () => {
                    this.onModalShown();
                });
                modalElement.addEventListener('hidden.bs.modal', () => {
                    this.onModalHidden();
                });
            }
        }
    }

    onModalShown() {
        this.isModalActive = true;
    }

    onModalHidden() {
        this.isModalActive = false;
    }

    ngOnInit(): void {
        this.updateCanonicalTag('/');

        this.routerSubscription = this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(() => {
            if (this.router.url === '/' || this.router.url === '/resources' || this.router.url === '/about-us' || this.router.url === '/privacy-policy' || this.router.url === '/terms-of-use' || this.router.url === '/contact-us' || this.router.url === '/faith' || this.router.url === '/health' || this.router.url === '/parents' || this.router.url === '/pets' || this.router.url === '/will' || this.router.url === '/estate' || this.router.url === '/funeral' || this.router.url === '/planning' || this.router.url === '/future' || this.router.url === '/parish' || this.router.url === '/college' || this.router.url === '/articles/a-complete-guide-to-planning-a-catholic-funeral-mass-step-by-step' || this.router.url === '/articles/how-can-the-catholic-funeral-mass-and-burial-tool-help-families-with-comprehensive-funeral-planning' || this.router.url === '/articles/key-considerations-for-catholic-healthcare-directives-and-medical-power-of-attorney' || this.router.url === '/articles/does-resuscitation-conflict-with-gods-plan' || this.router.url === '/articles/is-the-iron-dome-a-good-idea' || this.router.url === '/articles/the-terri-schiavo-case-and-the-vital-role-of-a-healthcare-directive-a-catholic-perspective') {
              this.ScriptService.injectJsonLdScript();
            }
          });
      }
    
    ngOnDestroy(): void {
        if (this.routerSubscription) {
          this.routerSubscription.unsubscribe();
        }
    }

    OnLogout() {
        if (!this.isLoggingOut) {
            this.isLoggingOut = true;
            this.subscription.add(
                this.dataService.get(URLS.logout).subscribe(data => {
                    if (data['code'] == 200) {
                        this.commonService.localStorageClear();
                        if (data['code'] == 200) {
                            this.toastr.success('Success', data['message']);
                        }
                        this.authService.logout();

                        sessionStorage.clear();
                        this.router.navigate(['/']);
                        this.isLoggingOut = false;
                        this.cancelLogoutModal.nativeElement.click();
                    } else {
                        this.toastr.error(data['message'], "Error");
                        setTimeout(() => {
                            if (data['message'] == 'Unauthorized Access') {
                                this.cancelLogoutModal.nativeElement.click();
                                this.router.navigate(['/login']);
                            }
                        }, 100);
                    }
                }, error => {
                    this.toastr.error(error['message'], "Error");
                    this.cancelLogoutModal.nativeElement.click();
                    this.commonService.localStorageClear();
                    this.router.navigate(['/']);
                })
            )
        }

    }

    setMetaTags() {
        // const currentUrl = this.router.url;

        // if (currentUrl === '/will') {
        const title = this.getTitle(
            this.router.routerState,
            this.router.routerState.root
        );
        

        if (title && title.length) {
            this.titleService.setTitle(title[title.length - 1].title);
            
            this.meta.updateTag({
                property: "og:title",
                content: title[title.length - 1].title,
            });
            this.meta.updateTag({ name: 'description', content: title[title.length - 1].description });
            this.meta.updateTag({
                property: "og:description",
                content: title[title.length - 1].description,
            });
            this.meta.updateTag({
                property: "og:image",
                content: title[title.length - 1].ogImage,
            });
            this.meta.updateTag({
                property: "og:url",
                content: title[title.length - 1].ogUrl,
            });
        }
        // }
    }

    updateCanonicalTag(url: string) {
        if (isPlatformBrowser(this.platformId)) {
            this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationEnd) {
                    let currentUrl = window.location.href;
                    // if (event.url == '/en' || event.url == '/ar') {
                    currentUrl = `${currentUrl}/`
                    // }
                }
            })
            const existingCanonical: HTMLLinkElement = this.getOrCreateCanonicalTag();
            existingCanonical.setAttribute('href', `${window.location.origin}${url}`);
        }
    }

    private getOrCreateCanonicalTag(): HTMLLinkElement {
        if (isPlatformBrowser(this.platformId)) {
            let link: HTMLLinkElement = this.document.querySelector("link[rel='canonical']");
            if (!link) {
                link = this.document.createElement('link');
                link.setAttribute('rel', 'canonical');
                this.document.head.appendChild(link);
            }
            return link;
        }
    }

    public getTitle(state, parent) {
        
        const data = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(
                { 
                    title: parent.snapshot.data.title,
                    description: parent.snapshot.data.description,
                    ogImage: parent.snapshot.data.ogImage,
                    ogUrl: parent.snapshot.data.ogUrl                    
                }
            );
        }

        if (state && parent) {
            data.push(... this.getTitle(state, state.firstChild(parent)));
        }
        return data;
    }

}
